<template>
    <v-sheet fill-height id="layout-inner-page" :color="baseBgColor">
        <v-app-bar app flat :clipped-left="$vuetify.breakpoint.lgAndUp" :color="appBarColor">
            <v-btn text icon @click="$router.go(-1)">
                <v-icon>$vuetify.icons.back</v-icon>
            </v-btn>
            <v-toolbar-title class="pa-0" v-html="title"></v-toolbar-title>

            <v-spacer></v-spacer>


            <v-btn icon small to="/dashboard">
                <v-avatar :size="32">
                    <BrandLogo />
                </v-avatar>
            </v-btn>
            <span></span>
        </v-app-bar>

        <v-main fill-height class="pos-r">
            <transition name="fade" mode="out-in">
                <slot />
            </transition>
        </v-main>
    </v-sheet>
</template>

<script>
    import {
        mapActions,
        mapGetters
    } from "vuex";

    import NetworkIndicator from '@/components/NetworkIndicator';
    import PwaInstallerBtn from '@/components/PwaInstallerBtn';

    export default {
        name: "InnerPageLayout",

        components: {
            NetworkIndicator,
            PwaInstallerBtn
        },

        computed: {
            ...mapGetters("customer", ["customer"]),
            ...mapGetters("auth", ["authenticated", "user"]),
            ...mapGetters("appshell", ["dark", "platform", "isMobileDevice", "loading", "sysNotifications"]),

            title() {
                return this.$route.meta.title;
            },
            lastRoute() {
                return localStorage.getItem("route_from") && JSON.parse(localStorage.getItem("route_from"));
            },
            appBarColor() {
                return !this.dark ? "white" : "black";
            },
            baseBgColor() {
                return !this.dark ? "grey lighten-4" : "black";
            }
        },

        methods: {
            ...mapActions("auth", ["login", "logout"]),
            ...mapActions("appshell", ["updateDark"]),
        },

        data() {
            return {}
        },

    }
</script>

<style lang="css" scoped>
    #layout-inner-page>>>.v-navigation-drawer__content {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: end;
    }

    small.alpha {
        font-size: 0.5rem;
        text-align: right;
        margin-right: 0.5rem;
        line-height: 1;
    }
</style>